import { EditorJsOutputData } from "@dashboard/utils/richText/types";

import { PageTypeContentModule } from "./types";

export const defaultCustomerServiceContent: PageTypeContentModule = {
  pageTypeSlug: "customer-service",
  suggestedTitles: ["Contact Us", "Support Center", "Help Desk", "FAQs"],
  suggestedSlugs: ["contact", "support", "help", "faq"],
  description: "Customer support, contact information, and help resources",

  content: {
    time: Date.now(),
    blocks: [
      {
        type: "header",
        data: { text: "Customer Support", level: 1 },
      },
      {
        type: "paragraph",
        data: {
          text: "We're here to help! Our dedicated support team is ready to assist you with any questions or concerns you may have.",
        },
      },
      {
        type: "header",
        data: { text: "Contact Information", level: 2 },
      },
      {
        type: "paragraph",
        data: {
          text: "Email: support@example.com<br>Phone: 1-800-EXAMPLE<br>Hours: Monday - Friday, 9AM - 5PM EST",
        },
      },
      {
        type: "header",
        data: { text: "How Can We Help?", level: 2 },
      },
      {
        type: "list",
        data: {
          style: "unordered",
          items: [
            "Order status and tracking",
            "Product information and recommendations",
            "Returns and exchanges",
            "Technical support",
            "Billing questions",
          ],
        },
      },
      {
        type: "header",
        data: { text: "Frequently Asked Questions", level: 2 },
      },
      {
        type: "paragraph",
        data: {
          text: "Check our FAQ section for quick answers to common questions. If you can't find what you're looking for, please reach out to our team.",
        },
      },
    ],
    version: "2.20.0",
  } as EditorJsOutputData,
};
